/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vpn_Feature_1Inputs */

const en_vpn_feature_1 = /** @type {(inputs: Vpn_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access content anywhere`)
};

const id_vpn_feature_1 = /** @type {(inputs: Vpn_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akses konten di mana saja`)
};

const ms_vpn_feature_1 = /** @type {(inputs: Vpn_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akses kandungan di mana-mana sahaja`)
};

const ca_vpn_feature_1 = /** @type {(inputs: Vpn_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedeix al contingut des de qualsevol lloc`)
};

const cs_vpn_feature_1 = /** @type {(inputs: Vpn_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přístup k obsahu odkudkoli`)
};

const da_vpn_feature_1 = /** @type {(inputs: Vpn_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Få adgang til indhold overalt`)
};

const de_vpn_feature_1 = /** @type {(inputs: Vpn_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugriff auf Inhalte weltweit`)
};

const et_vpn_feature_1 = /** @type {(inputs: Vpn_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juurdepääs igasugusele sisule`)
};

const es_vpn_feature_1 = /** @type {(inputs: Vpn_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accede a contenido desde donde quieras`)
};

const fr_vpn_feature_1 = /** @type {(inputs: Vpn_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accédez à vos contenus partout dans le monde`)
};

const hr_vpn_feature_1 = /** @type {(inputs: Vpn_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pristupite sadržaju bilo gdje`)
};

const it_vpn_feature_1 = /** @type {(inputs: Vpn_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accesso ai contenuti da qualsiasi dispositivo`)
};

const lv_vpn_feature_1 = /** @type {(inputs: Vpn_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piekļuve saturam no jebkurienes`)
};

const lt_vpn_feature_1 = /** @type {(inputs: Vpn_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasiekite turinį iš bet kurios vietos`)
};

const hu_vpn_feature_1 = /** @type {(inputs: Vpn_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tartalmak elérése bárhonnan`)
};

const nl_vpn_feature_1 = /** @type {(inputs: Vpn_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toegang tot wereldwijde content`)
};

const nb_vpn_feature_1 = /** @type {(inputs: Vpn_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilgang til innhold hvor som helst`)
};

const pl_vpn_feature_1 = /** @type {(inputs: Vpn_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostęp do treści w dowolnym miejscu`)
};

const pt_vpn_feature_1 = /** @type {(inputs: Vpn_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acesse conteúdo em qualquer lugar`)
};

const ro_vpn_feature_1 = /** @type {(inputs: Vpn_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accesează conținut oriunde`)
};

const sk_vpn_feature_1 = /** @type {(inputs: Vpn_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prístup k obsahu odkiaľkoľvek`)
};

const sl_vpn_feature_1 = /** @type {(inputs: Vpn_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostop do vsebine kjerkoli`)
};

const fi_vpn_feature_1 = /** @type {(inputs: Vpn_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käytä sisältöä missä tahansa`)
};

const sv_vpn_feature_1 = /** @type {(inputs: Vpn_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Få åtkomst till innehåll överallt`)
};

const vi_vpn_feature_1 = /** @type {(inputs: Vpn_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Truy cập nội dung ở mọi nơi`)
};

const tr_vpn_feature_1 = /** @type {(inputs: Vpn_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İçeriğe her yerden erişin`)
};

const el_vpn_feature_1 = /** @type {(inputs: Vpn_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Πρόσβαση σε περιεχόμενο οπουδήποτε`)
};

const bg_vpn_feature_1 = /** @type {(inputs: Vpn_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Достъп до съдържание навсякъде`)
};

const ru_vpn_feature_1 = /** @type {(inputs: Vpn_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доступ к контенту в любом месте`)
};

const sr_vpn_feature_1 = /** @type {(inputs: Vpn_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Приступите садржају било где`)
};

const uk_vpn_feature_1 = /** @type {(inputs: Vpn_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доступ до контенту будь-де`)
};

const ka_vpn_feature_1 = /** @type {(inputs: Vpn_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`კონტენტზე წვდომა ნებისმიერი ადგილიდან`)
};

const hi_vpn_feature_1 = /** @type {(inputs: Vpn_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कहीं भी कंटेंट एक्सेस करें `)
};

const th_vpn_feature_1 = /** @type {(inputs: Vpn_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เข้าถึงเนื้อหาได้ทุกที่`)
};

const ko_vpn_feature_1 = /** @type {(inputs: Vpn_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`자유로운 콘텐츠 액세스`)
};

const zh_vpn_feature_1 = /** @type {(inputs: Vpn_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`随时随地访问内容`)
};

const zh_tw_vpn_feature_1 = /** @type {(inputs: Vpn_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隨時隨地存取內容`)
};

const ja_vpn_feature_1 = /** @type {(inputs: Vpn_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どこでもコンテンツにアクセス`)
};

/**
* | output |
* | --- |
* | "Access content anywhere" |
*
* @param {Vpn_Feature_1Inputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const vpn_feature_1 = /** @type {((inputs?: Vpn_Feature_1Inputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vpn_Feature_1Inputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_vpn_feature_1(inputs)
	if (locale === "ms") return ms_vpn_feature_1(inputs)
	if (locale === "ca") return ca_vpn_feature_1(inputs)
	if (locale === "cs") return cs_vpn_feature_1(inputs)
	if (locale === "da") return da_vpn_feature_1(inputs)
	if (locale === "de") return de_vpn_feature_1(inputs)
	if (locale === "et") return et_vpn_feature_1(inputs)
	if (locale === "es") return es_vpn_feature_1(inputs)
	if (locale === "fr") return fr_vpn_feature_1(inputs)
	if (locale === "hr") return hr_vpn_feature_1(inputs)
	if (locale === "it") return it_vpn_feature_1(inputs)
	if (locale === "lv") return lv_vpn_feature_1(inputs)
	if (locale === "lt") return lt_vpn_feature_1(inputs)
	if (locale === "hu") return hu_vpn_feature_1(inputs)
	if (locale === "nl") return nl_vpn_feature_1(inputs)
	if (locale === "nb") return nb_vpn_feature_1(inputs)
	if (locale === "pl") return pl_vpn_feature_1(inputs)
	if (locale === "pt") return pt_vpn_feature_1(inputs)
	if (locale === "ro") return ro_vpn_feature_1(inputs)
	if (locale === "sk") return sk_vpn_feature_1(inputs)
	if (locale === "sl") return sl_vpn_feature_1(inputs)
	if (locale === "fi") return fi_vpn_feature_1(inputs)
	if (locale === "sv") return sv_vpn_feature_1(inputs)
	if (locale === "vi") return vi_vpn_feature_1(inputs)
	if (locale === "tr") return tr_vpn_feature_1(inputs)
	if (locale === "el") return el_vpn_feature_1(inputs)
	if (locale === "bg") return bg_vpn_feature_1(inputs)
	if (locale === "ru") return ru_vpn_feature_1(inputs)
	if (locale === "sr") return sr_vpn_feature_1(inputs)
	if (locale === "uk") return uk_vpn_feature_1(inputs)
	if (locale === "ka") return ka_vpn_feature_1(inputs)
	if (locale === "hi") return hi_vpn_feature_1(inputs)
	if (locale === "th") return th_vpn_feature_1(inputs)
	if (locale === "ko") return ko_vpn_feature_1(inputs)
	if (locale === "zh") return zh_vpn_feature_1(inputs)
	if (locale === "zh-tw") return zh_tw_vpn_feature_1(inputs)
	if (locale === "ja") return ja_vpn_feature_1(inputs)
	return en_vpn_feature_1(inputs)
});